import { clearAllManageTokens } from "../../pages/canchas/openMatchesModel";
import { LOGIN_SUCCESS, LOGOUT_SUCCESS, SESION_ZOCO_RENOVADA } from "../actions/action";

// `origen` y `negocio` solo los llenan las sesiones que salen del canje de Zoco
// (pages/auth/EntrarDesdeZoco.jsx): `origen: "zoco"` dice contra quién se renueva y se cierra,
// y `negocio: { id, nombre }` es el negocio del token, el que muestra el panel. Un login propio
// de Tickets los deja en null, porque no está parado en ningún negocio.
const defaultState = {
  isAuthenticated: false,
  user: null,
  accessToken: null,
  refreshToken: null,
  origen: null,
  negocio: null,
};

const authReducer = (state = defaultState, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        isAuthenticated: true,
        accessToken: action.payload.accessToken,
        refreshToken: action.payload.refreshToken,
        user: action.payload.user,
        origen: action.payload.origen || null,
        negocio: action.payload.negocio || null,
      };

    // Zoco rota el par de tokens al renovar, y nada más: el usuario y el negocio siguen siendo
    // los del canje. El negocio no puede cambiar renovando (03-seguridad, regla 5).
    case SESION_ZOCO_RENOVADA:
      return {
        ...state,
        accessToken: action.payload.accessToken,
        refreshToken: action.payload.refreshToken,
      };

    // Single choke point: Profile, the organizer Layout, the router guard and the 401 handlers in
    // api.js all dispatch LOGOUT_SUCCESS. The creator's open-match manage tokens must not outlive the
    // session, so they are wiped here (a deliberate side effect in the reducer; see T22).
    case LOGOUT_SUCCESS:
      clearAllManageTokens();
      return { ...state, isAuthenticated: false, user: null, accessToken: null, refreshToken: null, origen: null, negocio: null, cart: 0 };
    default:
      return state;
  }
};

export default authReducer;
